import { apiNWL, apiController, restartApiCotroller } from '@/utils/nwlApi';
import store from '@/redux/store';
import { setShowLoader } from '@/redux/slices/loaderSlice';

const getSites = async (orgId) => {
    try {
        restartApiCotroller();
        store.dispatch(setShowLoader(false));
        const response = await apiNWL.get(
            `/organisations/${orgId}/sites`,
            {
                signal: apiController.signal,
            },
        );
        return response.data || {};
    } catch (error) {
        console.error(error);
    }
};

const getSiteById = async (orgId, siteId) => {
    try {
        restartApiCotroller();
        store.dispatch(setShowLoader(false));
        const response = await apiNWL.get(
            `/organisations/${orgId}/sites/${siteId}`,
            {
                signal: apiController.signal,
            },
        );
        return response.data || {};
    } catch (error) {
        console.error(error);
    }
};

const getSitePredictions = async (orgId, siteId) => {
    try {
        restartApiCotroller();
        store.dispatch(setShowLoader(false));
        const response = await apiNWL.get(
            `/organisations/${orgId}/sites/${siteId}/predictions`,
            {
                signal: apiController.signal,
            },
        );
        return response.data || {};
    } catch (error) {
        console.error(error);
    }
};

const getSitePredictionById = async (orgId, siteId, predictionId) => {
    try {
        restartApiCotroller();
        store.dispatch(setShowLoader(false));
        const response = await apiNWL.get(
            `/organisations/${orgId}/sites/${siteId}/predictions/${predictionId}`,
            {
                signal: apiController.signal,
            },
        );
        return response.data || {};
    } catch (error) {
        console.error(error);
    }
};

export {
    getSites,
    getSiteById,
    getSitePredictions,
    getSitePredictionById
};
